import { Box, Icon, Text } from '@nimbus-ds/components';
import { DataList } from '@nimbus-ds/patterns';
import { Repeater } from 'commons/components';

function ItemSkeleton() {
  return (
    <DataList.Row>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box display="flex" flexDirection="column" gap="1">
          <Text.Skeleton width="200px" fontSize="base" />
          <Text.Skeleton width="150px" fontSize="caption" />
        </Box>
        <Icon.Skeleton />
      </Box>
    </DataList.Row>
  );
}

export function DomainSuggestionRowSkeleton() {
  return <Repeater times={5} item={ItemSkeleton} />;
}
